import type { ReactNode } from "react";

type Tone = "neutral" | "accent" | "primary" | "secondary";

const TONES: Record<Tone, string> = {
  neutral: "border-foreground-950 bg-background-100 text-foreground-800",
  accent: "border-accent-500 bg-accent-100 text-accent-800",
  primary: "border-primary-500 bg-primary-100 text-primary-800",
  secondary: "border-foreground-950 bg-secondary-100 text-secondary-900",
};

interface TagProps {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}

/** One badge recipe for the whole site: same box, same size, same tracking. */
export default function Tag({ children, tone = "neutral", className = "" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 border-2 font-label text-[10px] uppercase tracking-[0.14em] font-semibold whitespace-nowrap ${TONES[tone]} ${className}`}
    >
      {children}
    </span>
  );
}